"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var fast_json_stable_stringify_1 = tslib_1.__importDefault(require("fast-json-stable-stringify"));
var ts_md5_1 = require("ts-md5");
function hashObject(obj) {
    return ts_md5_1.Md5.hashStr(fast_json_stable_stringify_1.default(obj));
}
exports.default = hashObject;
